import store from '../store/Store';
import ConversationReadingPaneViewState from '../store/schema/ConversationReadingPaneViewState';

export default function getConversationReadingPaneViewState(): ConversationReadingPaneViewState {
    return store.conversationReadingPaneViewState;
}
